import React from 'react';
import cancelIcon from "assets/images/images_new/cancel.svg";
import { NavLink } from "react-router-dom";
import { Button } from 'react-bootstrap';

const CancelCard = () => {
  return (
    <div className="transation-page payment-successful outer-wrapper">
      <div className="successful-content">
        <img src={cancelIcon} alt="Payment Cancelled" />
        <h2>Subscription cancelled</h2>
        <p>Your Subscription was cancelled <br /> Continue shopping and checkout when you're ready</p>
        <div className="payment-btns d-flex justify-content-center align-items-center">
          <NavLink to={"/admin/plans"}>
            <button className="success-btn d-flex align-items-center">
              View Plans
            </button>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default CancelCard;